<script setup>
import {Link, usePage} from "@inertiajs/vue3";
import {computed} from "vue";
import { loadLanguageAsync } from 'laravel-vue-i18n';


const page = usePage();
// Error pages can be rendered before the Inertia middleware ran (e.g. a routing 404),
// in which case localizationState is not shared at all.
const localizationState = computed(() => page.props.localizationState ?? {availableLocales: {}, currentLocale: null});

</script>

<template>
  <div class="flex space-x-2 py-3">
    <div v-for="(lang, locale) in localizationState.availableLocales" class="uppercase">
      <template v-if="locale !== localizationState.currentLocale">
        <Link @click=" loadLanguageAsync(locale)" :href="lang.url" class="text-gray-500" :preserve-state="false">{{ locale }}</Link>
      </template>
      <template v-else>
          <span class="font-semibold">
            {{ locale }}
          </span>
      </template>
    </div>
  </div>
</template>
